interface QueryKeys {
  getIAMRoles: string;
  supervisorProfile: string;
  arePerformance: string;
  areDetail: string;
  areTarget: string;
  supervisorPerformance: string;
  getAreTarget: string;
  getSetTargetList: string;
  employeeDetail: string;
  getPerformanceDetails: string;
  getSwitchAreDetails: string;
  getAreHistoricalPerformanceMonthRange: string;
  getAreHistoricalPerformance: string;
  AgentPerformanceDetails: string;
  getAgentHistoricalPerformance: string;
  getPerformanceAgentMatrix: string;
  agentProfile: string;
  AgentData: string;
  ARELists: string;
  AREListBranch: string;
  ARETargetList: string;
  AgentMaintainable: string;
  getMaintainARESchedule: string;
  getMaintainMaintainAssignment: string;
  getMaintainReportDetail: string;
  getRecruitActivity: string;
  getRecruitmentList: string;
  getRecruitmentReport: string;
  getRecruitmentDetail: string;
  getMaintainActivityReport: string;
  getGeneral: string;
  getSearchCity: string;
  getSearch: string;
  getRecruitWeeklyTarget: string;
  getRecruitAssignmentList: string;
  getRecruitAll: string;
  getJoinVisitReport: string;
  getJoinVisitAreList: string;
  getJoinVisitQuestionList: string;
  getJoinVisitSummary: string;
  getLeadsTrackerList: string;
  getLeadsTrackerDetails: string;
  getOneOnOneAREList: string;
  getAverageMaintainRating: string;
  getAggregatedMaintainFeedback: string;
  getPreviousActionPlan: string;
  getARERecruitPerformace: string;
  getRecruitPerformanceArea: string;
  SPVList: string;
  Branch: string;
  AgentList: string;
  GroupMeetingReport: string;
  GroupMeetingDetail: string;
  IncentiveType: string;
  IncentiveReport: string;
  IncentiveProgram: string;
  MediaBrochures: string;
}

const queryKeys: QueryKeys = {
  getIAMRoles: 'getIAMRoles',
  supervisorProfile: 'supervisorProfile',
  arePerformance: 'arePerformance',
  areDetail: 'areDetail',
  areTarget: 'areTarget',
  supervisorPerformance: 'supervisorPerformance',
  getAreTarget: 'getAreTarget',
  getSetTargetList: 'getSetTargetList',
  employeeDetail: 'employeeDetail',
  getPerformanceDetails: 'getPerformanceDetails',
  getSwitchAreDetails: 'getSwitchAreDetails',
  getAreHistoricalPerformanceMonthRange:
    'getAreHistoricalPerformanceMonthRange',
  getAreHistoricalPerformance: 'getAreHistoricalPerformance',
  AgentPerformanceDetails: 'AgentPerformanceThisMonth',
  getAgentHistoricalPerformance: 'getAgentHistoricalPerformance',
  getPerformanceAgentMatrix: 'getPerformanceAgentMatrix',
  agentProfile: 'agentProfile',
  AgentData: 'AgentData',
  ARELists: 'ARELists',
  AREListBranch: 'AREListBranch',
  ARETargetList: 'ARETargetList',
  AgentMaintainable: 'AgentMaintainable',
  getMaintainARESchedule: 'getMaintainARESchedule',
  getMaintainMaintainAssignment: 'getMaintainMaintainAssignment',
  getMaintainReportDetail: 'getMaintainReportDetail',
  getRecruitActivity: 'getRecruitActivity',
  getRecruitmentList: 'getRecruitmentList',
  getRecruitmentReport: 'getRecruitmentReport',
  getRecruitmentDetail: 'getRecruitmentDetail',
  getMaintainActivityReport: 'getMaintainActivityReport',
  getGeneral: 'getGeneral',
  getSearch: 'getSearch',
  getSearchCity: 'getSearchCity',
  getRecruitWeeklyTarget: 'getRecruitWeeklyTarget',
  getRecruitAssignmentList: 'getRecruitAssignmentList',
  getRecruitAll: 'getRecruitAll',
  getJoinVisitReport: 'getJoinVisitReport',
  getJoinVisitAreList: 'getJoinVisitAreList',
  getJoinVisitQuestionList: 'getJoinVisitQuestionList',
  getJoinVisitSummary: 'getJoinVisitSummary',
  getLeadsTrackerList: 'getLeadsTrackerList',
  getLeadsTrackerDetails: 'getLeadsTrackerDetails',
  getOneOnOneAREList: 'getOneOnOneAREList',
  getAverageMaintainRating: 'getAverageMaintainRating',
  getAggregatedMaintainFeedback: 'getAggregatedMaintainFeedback',
  getPreviousActionPlan: 'getPreviousActionPlan',
  getARERecruitPerformace: 'getARERecruitPerformace',
  getRecruitPerformanceArea: 'getRecruitPerformanceArea',
  SPVList: 'SPVList',
  Branch: 'Branch',
  AgentList: 'AgentList',
  GroupMeetingReport: 'GroupMeetingReport',
  GroupMeetingDetail: 'GroupMeetingDetail',
  IncentiveType: 'IncentiveType',
  IncentiveReport: 'IncentiveReport',
  IncentiveProgram: 'IncentiveProgram',
  MediaBrochures: 'MediaBrochures',
};

export default queryKeys;
